import { Injectable } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class FormatService {
  private datePipe = new DatePipe('en-US');
  private decimalPipe = new DecimalPipe('en-US');

  formatReport(report: any) {
    return {
        dateCreated: report.dateCreated ? this.datePipe.transform(report.dateCreated, 'short') : '---',
        partnerName: report.partnerName || '---',
        location: report.location || '---',
        createdByUserName: report.createdByUserName || '---',
        channel: report.channel || '---',
        clientName: report.client ? `${report.client.firstName} ${report.client.lastName}` : '---',
        nationalId: report.client ? report.client.nationalId : '---',
        vehicleType: report.vehicle ? report.vehicle.type : '---',
        vrn: report.vehicle ? report.vehicle.vrn : '---',
        insuranceType: report.insuranceType || '---',
        policyType: report.policyType || '---',
        startDate: report.cover ? this.datePipe.transform(report.cover.startDate, 'short') : '---',
        endDate: report.cover ? this.datePipe.transform(report.cover.endDate, 'short') : '---',
        transactionNumber: report.transactionNumber || '---',
        policyNumber: report.cover ? report.cover.policyNumber : '---',
        receiptNumber: report.licence ? report.licence.receiptNumber : '---',
        currency: report.actualCurrency ? report.actualCurrency.name : '---',
        coverAmount: report.cover ? this.decimalPipe.transform(report.cover.coverAmount, '1.2-2') : '---',
        governmentLevy: report.cover ? this.decimalPipe.transform(report.cover.governmentLevy, '1.2-2') : '---',
        stampDuty: report.cover ? this.decimalPipe.transform(report.cover.stampDuty, '1.2-2') : '---',
        premiumAmount: report.cover ? this.decimalPipe.transform(report.cover.premiumAmount, '1.2-2') : '---',
        totalLicenceAmount: report.licence ? this.decimalPipe.transform(report.licence.totalLicenceAmount, '1.2-2') : '---',
        totalRadioTvAmount: report.licence ? this.decimalPipe.transform(report.licence.totalRadioTvAmount, '1.2-2') : '---',
        actualTotal: report.actualTotal ? this.decimalPipe.transform(report.actualTotal, '1.2-2') : '---',
        status: report.status || '---',
        paymentMethod: report.paymentMethod || '---',
    };
  }
}
